<div class="image-viewer-container" (click)="onBackgroundClick($event)" (keydown.enter)="closeViewer.emit()" (wheel)="onWheel($event)">
  <!-- Close button -->
  <button class="image-viewer-close-btn" (click)="closeViewer.emit()" title="Close">
    <i class="fa fa-times"></i>
  </button>

  <!-- Zoom controls -->
  <div class="image-viewer-controls">
    <button class="image-viewer-control-btn" (click)="zoomOut()" [disabled]="zoomLevel <= MIN_ZOOM" title="Zoom out">
      <i class="fa fa-search-minus"></i>
    </button>
    <span class="image-viewer-zoom-label">{{ zoomLevel }}%</span>
    <button class="image-viewer-control-btn" (click)="zoomIn()" [disabled]="zoomLevel >= MAX_ZOOM" title="Zoom in">
      <i class="fa fa-search-plus"></i>
    </button>
    <button class="image-viewer-control-btn" (click)="resetZoom()" title="Reset zoom">
      <i class="fa fa-compress"></i>
    </button>
  </div>

  <!-- Scrollable image area -->
  <div class="image-viewer-scroll-area">
    <img
      [src]="imageUrl"
      [style.width.px]="zoomedWidth"
      [class.image-viewer-img-fit]="zoomLevel === 100"
      class="image-viewer-img"
      alt="Fullscreen image preview"
      (load)="onImageLoad($event)"
    />
  </div>
</div>
